export enum RoutesEnum {
  ROOT = '',
  LOGIN = 'login',
  EMAIL_ACTIONS = 'email-actions',
  SAMPLE = 'sample',
  WRAPPED = 'wrapped',
  TEAMS = 'teams',
  NOT_FOUND = 'not-found',
  USER_MANAGEMENT = 'user-management',
  DIRECT_COLLECTION = 'direct-collection',
  THREAT_ENTITY = 'threat-entity',
  CLIENT_METRICS = 'metrics',
  CLIENT_SUBSCRIPTIONS = 'subscriptions',
  CLIENT_SUBSCRIPTION_LIST = 'subscription-list',
  CLIENT = 'client',
  BOTNET_REPORTS = 'botnet-reports',
  INFECTIONS = 'infections',
  FRAUD_ALERTS = 'fraud-alerts',
  BREACH_INFO = 'breach-info',
  CARDS = 'cards',
  SOURCES = 'sources',
  ALERT_BUILDER = 'alert-builder',
  BANNER_MANAGER = 'banner-manager',
  FILE_SHARE = 'file-share',
  CHECK_RECORDS = 'check-records',
  PORTAL_CONFIG = 'portal-config',
  PORTAL_FAQ = 'portal-faq',
}
